import { render, staticRenderFns } from "./gauge-chart.vue?vue&type=template&id=7070dc60&scoped=true"
import script from "./gauge-chart.vue?vue&type=script&lang=js"
export * from "./gauge-chart.vue?vue&type=script&lang=js"
import style0 from "./gauge-chart.vue?vue&type=style&index=0&id=7070dc60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7070dc60",
  null
  
)

export default component.exports